export const getKeyTypePair = `query Get($key: String, $type: String) {
  get(key: $key, type: $type) {
    result
  }
}
`
